import { render } from "./SegmentControl_icon.vue?vue&type=template&id=686fb067&scoped=true"
import script from "./SegmentControl_icon.vue?vue&type=script&lang=js"
export * from "./SegmentControl_icon.vue?vue&type=script&lang=js"

import "./SegmentControl_icon.vue?vue&type=style&index=0&id=686fb067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686fb067"]])

export default __exports__